import React, { useEffect, useState } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { Send, CheckCircle } from 'lucide-react';
export function FreeTrialPage() {
  const [formState, setFormState] = useState<'idle' | 'submitting' | 'success'>('idle');
  useEffect(() => {
    document.title = "Free Trial | Walker's Martial Arts | Bloomington, Illinois";
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormState('submitting');
    // Simulate API call
    setTimeout(() => {
      setFormState('success');
    }, 1500);
  };
  return <div className="bg-black min-h-screen" data-id="element-538">
      <Navigation data-id="element-539" />

      {/* Page Header */}
      <div className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-540">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-541">
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6 text-center" data-id="element-542">
            <span className="text-[#00D4FF]" data-id="element-543">COMPLIMENTARY</span> FREE WEEK
          </h1>
        </motion.div>
      </div>

      {/* Content Section */}
      <section className="py-12 bg-[#0a0a0a]" data-id="element-544">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-545">
          <div className="bg-[#1a1a1a] rounded-3xl shadow-2xl overflow-hidden border border-gray-800" data-id="element-546">
            <div className="p-8 md:p-12" data-id="element-547">
              {formState === 'success' ? <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} className="h-full flex flex-col items-center justify-center text-center p-6" data-id="element-548">
                  <div className="w-16 h-16 bg-green-100 text-green-500 rounded-full flex items-center justify-center mb-4" data-id="element-549">
                    <CheckCircle size={32} data-id="element-550" />
                  </div>
                  <h4 className="text-2xl font-bold text-white mb-2" data-id="element-551">
                    Request Sent!
                  </h4>
                  <p className="text-gray-400" data-id="element-552">
                    We'll be in touch shortly to schedule your free week.
                  </p>
                  <button onClick={() => setFormState('idle')} className="mt-8 text-[#00D4FF] font-bold hover:underline" data-id="element-553">
                    Send another request
                  </button>
                </motion.div> : <>
                  {/* Content */}
                  <div className="mb-10 space-y-6 text-gray-300 leading-relaxed" data-id="element-554">
                    <p data-id="element-555">
                      Perhaps you want to get fit or ensure the safety of
                      yourself and your family in today's world. The journey
                      towards physical fitness and personal safety can start
                      with a single thought: the desire for positive change.
                    </p>
                    <p data-id="element-556">
                      Walker's Martial Arts offers a structured way to achieve
                      these goals. By engaging in regular practice, you can
                      improve your physical fitness through skill development,
                      strength training, and cardiovascular conditioning. The
                      intensity of martial arts workouts will enhance your
                      stamina, flexibility, and overall health.
                    </p>
                    <p data-id="element-557">
                      In addition to fitness, martial arts training equips you
                      with self-defense techniques, empowering you to respond
                      effectively in potentially dangerous situations. This
                      training not only builds physical skills but also fosters
                      mental discipline and confidence.
                    </p>
                    <p data-id="element-558">
                      Get involved with a supportive community, where you and
                      your family can grow together in skills, fitness, and
                      safety. Every class provides a unique opportunity to
                      learn, practice, and build resilience.
                    </p>
                    <p className="font-semibold text-white" data-id="element-559">
                      The idea of getting fit and staying safe can transform
                      into a rewarding reality. Start your journey today.
                    </p>
                  </div>

                  {/* Form */}
                  <form onSubmit={handleSubmit} className="space-y-6" data-id="element-560">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-561">
                      <div data-id="element-562">
                        <label htmlFor="firstName" className="block text-sm font-medium text-gray-400 mb-2" data-id="element-563">
                          First Name <span className="text-red-500" data-id="element-564">*</span>
                        </label>
                        <input type="text" id="firstName" required className="w-full px-4 py-3 rounded-lg border border-gray-700 bg-black text-white focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent outline-none transition-all" placeholder="First Name" data-id="element-565" />
                      </div>
                      <div data-id="element-566">
                        <label htmlFor="lastName" className="block text-sm font-medium text-gray-400 mb-2" data-id="element-567">
                          Last Name <span className="text-red-500" data-id="element-568">*</span>
                        </label>
                        <input type="text" id="lastName" required className="w-full px-4 py-3 rounded-lg border border-gray-700 bg-black text-white focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent outline-none transition-all" placeholder="Last Name" data-id="element-569" />
                      </div>
                    </div>

                    <div data-id="element-570">
                      <label htmlFor="email" className="block text-sm font-medium text-gray-400 mb-2" data-id="element-571">
                        Email <span className="text-red-500" data-id="element-572">*</span>
                      </label>
                      <input type="email" id="email" required className="w-full px-4 py-3 rounded-lg border border-gray-700 bg-black text-white focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent outline-none transition-all" placeholder="Email" data-id="element-573" />
                    </div>

                    <div data-id="element-574">
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-400 mb-2" data-id="element-575">
                        Phone <span className="text-red-500" data-id="element-576">*</span>
                      </label>
                      <input type="tel" id="phone" required className="w-full px-4 py-3 rounded-lg border border-gray-700 bg-black text-white focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent outline-none transition-all" placeholder="Phone" data-id="element-577" />
                    </div>

                    <div data-id="element-578">
                      <label htmlFor="class" className="block text-sm font-medium text-gray-400 mb-2" data-id="element-579">
                        What class would you like to try?{' '}
                        <span className="text-red-500" data-id="element-580">*</span>
                      </label>
                      <select id="class" required className="w-full px-4 py-3 rounded-lg border border-gray-700 bg-black text-white focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent outline-none transition-all" data-id="element-581">
                        <option value="" data-id="element-582">Select an option</option>
                        <option value="taekwondo" data-id="element-583">Taekwondo</option>
                        <option value="kickboxing" data-id="element-584">Kickboxing</option>
                      </select>
                    </div>

                    <div data-id="element-585">
                      <label htmlFor="details" className="block text-sm font-medium text-gray-400 mb-2" data-id="element-586">
                        Please provide name(s), age(s) & date you would like to
                        start
                      </label>
                      <textarea id="details" rows={4} className="w-full px-4 py-3 rounded-lg border border-gray-700 bg-black text-white focus:ring-2 focus:ring-[#00D4FF] focus:border-transparent outline-none transition-all resize-none" placeholder="Enter details here..." data-id="element-587" />
                    </div>

                    <button type="submit" disabled={formState === 'submitting'} className="w-full bg-[#00D4FF] text-black font-bold py-4 rounded-lg uppercase tracking-wider hover:bg-[#33ddff] transition-colors flex items-center justify-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed shadow-[0_0_20px_rgba(0,212,255,0.3)]" data-id="element-588">
                      {formState === 'submitting' ? 'Sending...' : 'Send'}
                      {formState === 'idle' && <Send size={18} data-id="element-589" />}
                    </button>
                  </form>
                </>}
            </div>
          </div>
        </div>
      </section>

      <Footer data-id="element-590" />
    </div>;
}